import { Reducer } from 'redux';
import { ApplicationState } from '..';



const initialReportState: ApplicationState = {
    tasks: [],
    user: {}
}



export const reportsReducer: Reducer = (state: ApplicationState = initialReportState, action): ApplicationState => {
    switch (action.type) {
        case 'REPORTS_COLLECTION':
            return {
                ...state,
                tasks: action.tasks
            }
        case 'EMPLOYEE_DATA':
            return {
                ...state,
                user: action.user
            }
        case 'DESTROY_SESSION':
            return {
                tasks: undefined,
                user: {}
            }
        default:
            return state;
    }

}

